module.exports = __webpack_public_path__ + "img/uy.2fd8e470.png";